// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"140":"c47517f9","152":"1a5155f1","233":"c3f96106","290":"7a27d117","310":"a4057b0e","794":"c9b65920","897":"9830af39","938":"df197b78"}[chunkId] + ".css";
};